module.exports = __webpack_public_path__ + "static/covid_c2.62cee87f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/covid_c2.png
// module id = 3065
// module chunks = 201276295743644